export type CategoryType =
  | 'playlist'
  | 'mood'
  | 'style'
  | 'daytime'
  | 'business'
  | 'genre'

export type Gradient = { a: string; b: string }

// --- быстрый стабильный хэш строки (cyrb53) ---
function hashString(str: string, seed = 0): number {
  let h1 = 0xdeadbeef ^ seed
  let h2 = 0x41c6ce57 ^ seed

  for (let i = 0, ch: number; i < str.length; i++) {
    ch = str.charCodeAt(i)
    h1 = Math.imul(h1 ^ ch, 2654435761)
    h2 = Math.imul(h2 ^ ch, 1597334677)
  }

  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909)
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909)

  return 4294967296 * (2097151 & h2) + (h1 >>> 0)
}

function hslToHex(h: number, s: number, l: number): string {
  s /= 100
  l /= 100

  const c = (1 - Math.abs(2 * l - 1)) * s
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1))
  const m = l - c / 2

  let r = 0,
    g = 0,
    b = 0

  if (h >= 0 && h < 60) {
    r = c
    g = x
  } else if (h >= 60 && h < 120) {
    r = x
    g = c
  } else if (h >= 120 && h < 180) {
    g = c
    b = x
  } else if (h >= 180 && h < 240) {
    g = x
    b = c
  } else if (h >= 240 && h < 300) {
    r = x
    b = c
  } else {
    r = c
    b = x
  }

  const toHex = (n: number) => {
    const v = Math.round((n + m) * 255)
    return v.toString(16).padStart(2, '0')
  }

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`
}

function typeSeed(type: CategoryType): number {
  switch (type) {
    case 'playlist':
      return 11
    case 'mood':
      return 22
    case 'genre':
      return 23
    case 'style':
      return 33
    case 'daytime':
      return 44
    case 'business':
      return 55
    default:
      return 0
  }
}

function typeParams(type: CategoryType) {
  switch (type) {
    case 'daytime':
      return { sat: 78, lightA: 58, lightB: 16 }
    case 'business':
      return { sat: 70, lightA: 56, lightB: 15 }
    case 'mood':
    case 'genre':
      return { sat: 82, lightA: 62, lightB: 18 }
    case 'style':
      return { sat: 76, lightA: 56, lightB: 14 }
    case 'playlist':
    default:
      return { sat: 80, lightA: 55, lightB: 14 }
  }
}

const accentCache = new Map<string, string>()
const gradientCache = new Map<string, Gradient>()

export function getAccentById(id: string, type: CategoryType = 'playlist'): string {
  const key = `${type}:${id}`
  const cached = accentCache.get(key)
  if (cached) return cached

  const h = hashString(id, typeSeed(type))
  const hue = h % 360
  const { sat, lightA } = typeParams(type)
  const color = hslToHex(hue, sat, lightA)

  accentCache.set(key, color)
  return color
}

export function getGradientById(id: string, type: CategoryType = 'playlist'): Gradient {
  const key = `${type}:${id}`
  const cached = gradientCache.get(key)
  if (cached) return cached

  const h = hashString(id, typeSeed(type))
  const hue = h % 360
  const { sat, lightA, lightB } = typeParams(type)

  // A — яркая, B — тёмная
  const a = hslToHex(hue, sat, lightA)
  const b = hslToHex(hue, sat, lightB)

  const grad = { a, b }
  gradientCache.set(key, grad)
  return grad
}
